export const SERVER=window.location.origin.includes('3000') ? 'http://localhost:8002':window.location.origin;
export const API_ENDPOINTS={};
export const DRIVE_CLIENT_ID="520838752205-8ne8o42j11fs4eorm52f8ngnfej5vhko.apps.googleusercontent.com";